const statuses = {
  invited: {
    name: 'invited',
    icon: 'img/campaigns/add.svg',
    icon_a: 'img/campaigns/add.svg'
  },
  invite_rejected: {
    name: 'invite_rejected',
    icon: 'img/campaigns/x.svg',
    icon_a: 'img/campaigns/x.svg'
  },
  invite_accepted: {
    name: 'invite_accepted',
    icon: 'img/campaigns/wait.svg',
    icon_a: 'img/campaigns/ok2.svg'
  },
  waiting_for_draft: {
    name: 'waiting_for_draft',
    icon: 'img/campaigns/infinity.png',
    icon_a: 'img/campaigns/wait.svg'
  },
  waiting_fot_draft_approval: {
    name: 'waiting_fot_draft_approval',
    icon: 'img/campaigns/wait.svg',
    icon_a: 'img/campaigns/check.svg'
  },
  waiting_fot_publication: {
    name: 'waiting_fot_publication',
    icon: 'img/campaigns/infinity.png',
    icon_a: 'img/campaigns/wait.svg'
  },
  waiting_for_publication_approval: {
    name: 'waiting_for_publication_approval',
    icon: 'img/campaigns/wait.svg',
    icon_a: 'img/campaigns/check.svg'
  },
  expired: {
    name: 'expired',
    icon: 'img/campaigns/no.svg',
    icon_a: 'img/campaigns/no.svg'
  },
  canceled: {
    name: 'canceled',
    icon: 'img/campaigns/x.svg',
    icon_a: 'img/campaigns/x.svg'
  },
  completed: {
    name: 'completed',
    icon: 'img/campaigns/ok.svg',
    icon_a: 'img/campaigns/ok.svg'
  }
}

export default statuses
